import { useQuery } from "@tanstack/react-query";

import { Permission } from "@/common/types/permissions.types";
import { useApi } from "@/core/libs/api/react-query/useApi";
import { FetchResponse } from "@/core/libs/api/utils/fetchData";
import { useAuth } from "@/core/libs/use-auth";
import { Profile } from "@/modules/User/types";
import { transformPermissions } from "@/utils/TransformPermissions";

export const useGetProfile = () => {
  const { execute } = useApi();
  const { isAuthenticated } = useAuth();

  return useQuery<FetchResponse<Profile>, Error, FetchResponse<Profile>>({
    queryKey: ["profile"],
    queryFn: () =>
      execute<Profile>({
        url: "users/profile?query=true",
        notificationMessage: "Buscando Profile"
      }),
    staleTime: Infinity,
    enabled: isAuthenticated,
    select: response => {
      if (!response?.data) return response;

      const rolePermissions = response.data.role?.permissions;
      const userPermissions = response.data.permissions || [];

      if (Array.isArray(rolePermissions)) {
        response.data.role.permissions = transformPermissions([
          ...(rolePermissions as Permission[]),
          ...userPermissions
        ]);
      }

      return response;
    }
  });
};
